module.exports = __webpack_public_path__ + "img/Mercado_LibreNew.04e42a23.png";